// Read-only review payload of a completed worksheet. Stored inside the
// element's Completed status (interactiveElementState), so score and answers
// are written, read and cleared together.

export interface WorksheetTaskAnswer {
  value: string;
  correct: boolean;
  grade?: string;
  feedback: string;
}

export interface WorksheetAnswerRecord {
  // Keyed by task id (both main and additional tasks).
  answers: Record<string, WorksheetTaskAnswer>;
  doBonus: boolean;
}

// Discriminates on `doBonus`: self-reflection records also carry `answers`.
export const isWorksheetAnswerRecord = (
  review: unknown
): review is WorksheetAnswerRecord =>
  !!review && typeof review === "object" && "doBonus" in review;
